import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Tasks from 'APP/Tasks';
import useGetParameter from 'APP/router/hooks/useGetParameter';

interface ILoginByCodeResult {
  isLoggingIn: boolean;
  code: string;
}

export function useLoginByCode(): ILoginByCodeResult {
  const [_, setCurrentSearchParams] = useSearchParams();
  const code = useGetParameter('code') || '';
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  async function login(): Promise<void> {
    setIsLoggingIn(true);
    await Tasks.authorization.loginByCode(code);
    manageSeachParams();
    setIsLoggingIn(false);
  }

  function manageSeachParams(): void {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const state = currentSearchParams.get('state');
    const searchQuery = state ? Tasks.authorization.getAndClearOAuthReturnUrl(state) : '';
    setCurrentSearchParams(new URLSearchParams(searchQuery || ''), { replace: true });
  }

  useEffect(() => {
    if (!code) {
      return;
    }
    login();
  }, [code]);

  return { isLoggingIn, code };
}
